import { render } from "./IsCheRightForYouNow.vue?vue&type=template&id=bbd9f690&scoped=true"
import script from "./IsCheRightForYouNow.vue?vue&type=script&lang=js"
export * from "./IsCheRightForYouNow.vue?vue&type=script&lang=js"

import "./IsCheRightForYouNow.vue?vue&type=style&index=0&id=bbd9f690&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd9f690"]])

export default __exports__